export const EN = {
  EMAIL_WEB: 'Email/Web',
  PIN_ON_RECEIPT: 'Pin on Receipt',
  PHYSICAL_SOLD_ONLINE: 'Physical Sold Online',

  DIGITALFILE_A_IMG_PRD: 'Product Image',
  DIGITALFILE_A_IMG_BRAND_LOGO: 'Brand Logo',
  DIGITALFILE_A_IMG_HDR: 'Header',
  DIGITALFILE_A_IMG_FTR: 'Footer',
  DIGITALFILE_O_IMG_MEDIA: 'Original Media',
  DIGITALFILE_O_CARDAGRMNT: 'Original Cardholder Agreement',

  DIGITALFILE_A_IMG_PRD_82_118: 'GC-82x118',
  DIGITALFILE_A_IMG_PRD_180_260: 'GC-180x260',
  DIGITALFILE_A_IMG_PRD_136_86: 'GC-136x86',
  DIGITALFILE_A_IMG_PRD_200_283: 'GC-200x283 - M6/Vertical Card Image',
  DIGITALFILE_A_IMG_PRD_300_190: 'GC-300x190 - CR80/Horizontal Card Image',
  DIGITALFILE_A_IMG_PRD_1500_1500: 'GC-1500x1500 - Image for External Merchant Sites',
  DIGITALFILE_A_IMG_PRD_1500_1500_IDS: 'GC-1500x1500-IDS',
 // DIGITALFILE_A_IMG_PRD_1500_1500_ECARD: 'GC-1500x1500-eCard',
  DIGITALFILE_A_IMG_BRAND_LOGO_600_380: 'LOGO-600x380',
  DIGITALFILE_A_IMG_HDR_670_123: 'HDR-670x123',
  DIGITALFILE_A_IMG_FTR_670_91: 'FTR-670x91',
  DIGITALFILE_A_IMG_BRAND_LOGO_EPS: 'Logo EPS',
  DIGITALFILE_D_IMG_MEDIA: 'Final Media',
  DIGITALFILE_A_CARDAGRMNT: 'Final Cardholder Agreement',

  DRAFT: 'Draft',
  PROCESSING:  'Processing',
  STAGED: 'Staged',
  PRODUCTION: 'Production',
  ABANDONED: 'Abandoned',

  PRODUCT_LEVEL: 'Product',
  EMAIL_WEB_LEVEL: 'Email/Web',
  PIN_ON_RECEIPT_LEVEL: 'Pin on Receipt',

  MARKETING_DETAILS: 'Marketing Details',
  REDEMPTION_DETAILS: 'Redemption Details',
  DIGITAL_FILES_ORIGINAL: 'Original Art Files',
  DIGITAL_FILES_FINAL: 'Final Art Files',

  DIGITAL_FILES_ORIGINAL_HEADING: 'Original Art Files',
  DIGITAL_FILES_FINAL_HEADING: 'Final Art Files',
  DIGITAL: 'Digital',
  PHYSICAL: 'Physical',
  NO_PLATFORMS: 'No Platforms',

  GROUP_MARKETING_DETAILS: 'Group Marketing Details',
  GROUP_DETAILS: 'Group Details',
  GROUP_REDEMPTION_INSTRUCTIONS: 'Group Redemption Instructions',
  GROUP_REDEMPTION_DETAILS: 'Group Redemption Details',
  GROUP_ORIGINAL_ART_FILES: 'Group Original Art Files',
  GROUP_FINAL_ART_FILES: 'Group Final Art Files'
};
